/* eslint-disable react/jsx-no-duplicate-props */

import React, { PureComponent } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import MomentUtils from '@date-io/moment'
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { withStyles } from '@material-ui/core/styles'

import Select from './Select'


const styles = theme => ({
  root: {
    width: '100%',
  },
  focused: {},
  formControl: {},
  notchedOutline: {},
  secondary: {
    '&$focused $notchedOutline': {
      borderColor: theme.palette.secondary.main,
    },
  },
  input: {
    backgroundColor: 'white',
    color: theme.palette.common.black,
    fontSize: 14,
    fontWeight: 300,
    height: 20,
    padding: '10px 20px',

    '&::placeholder, &::-webkit-input-placeholder': {
      color: theme.palette.common.black,
    },
  },
})


class RangeDate extends PureComponent {
  /* LIFECYCLE */

  state = {
    quickView: '',
  }


  /* METHODS */


  handleQuickViewChange = (e) => {
    this.props.onChange({ target: { name: 'endDate', value: moment() } })

    switch (e.target.value) {
      case 'month': this.props.onChange({ target: { name: 'startDate', value: moment().startOf('month') } })
        break

      case 'month3': this.props.onChange({ target: { name: 'startDate', value: moment().set({ month: moment().month() - 3 }).startOf('month') } })
        break

      case 'month6': this.props.onChange({ target: { name: 'startDate', value: moment().set({ month: moment().month() - 6 }).startOf('month') } })
        break

      case 'year': this.props.onChange({ target: { name: 'startDate', value: moment().startOf('year') } })
        break

      case 'year2': this.props.onChange({ target: { name: 'startDate', value: moment().set({ year: moment().year() - 1 }).startOf('year') } })
        break

      case 'year3': this.props.onChange({ target: { name: 'startDate', value: moment().set({ year: moment().year() - 2 }).startOf('year') } })
        break

      default: this.props.onChange({ target: { name: 'startDate', value: moment().startOf('week') } })
        break
    }

    this.setState({ quickView: e.target.value }, () => {
      if (this.props.onQuickViewChange) {
        this.props.onQuickViewChange(e.target.value)
      }
    })
  }

  handleChange = name => (value) => {
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name,
          value,
        },
      })
    }
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      label,
      classes,
      endDate,
      labelEnd,
      startDate,
      className,
      labelStart,
    } = this.props
    const { quickView } = this.state

    return (
      <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="fr">
        <div className={classNames(classes.root, className)}>
          <Grid
            container
            alignItems="center"
            justify="space-between"
          >
            <KeyboardDatePicker
              name="startDate"
              color="primary"
              value={startDate}
              format="DD/MM/YYYY"
              initialFocusedDate=""
              inputVariant="outlined"
              label={label || labelStart}
              id="date-picker-start-dialog"
              onChange={this.handleChange('startDate')}
              inputProps={{
                autoComplete: 'nope',
                className: classes.input,
              }}
              InputProps={{
                classes: {
                  root: classes.primary,
                  focused: classes.focused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.inputLabel,
              }}
            />
            <KeyboardDatePicker
              name="endDate"
              value={endDate}
              className="ml2"
              color="primary"
              format="DD/MM/YYYY"
              inputVariant="outlined"
              label={label || labelEnd}
              id="date-picker-start-dialog"
              onChange={this.handleChange('endDate')}
              inputProps={{
                autoComplete: 'nope',
                className: classes.input,
              }}
              InputProps={{
                classes: {
                  root: classes.secondary,
                  focused: classes.focused,
                  notchedOutline: classes.notchedOutline,
                },
              }}
              InputLabelProps={{
                shrink: true,
                className: classes.inputLabel,
              }}
            />

            <Select
              className="ml2"
              name="quickView"
              value={quickView}
              label="Vue rapide"
              onChange={this.handleQuickViewChange}
            >
              <MenuItem value="week">Cette semaine</MenuItem>
              <MenuItem value="month">Ce mois-ci</MenuItem>
              <MenuItem value="month3">Ces 3 derniers mois</MenuItem>
              <MenuItem value="month6">Ces 6 derniers mois</MenuItem>
              <MenuItem value="year">Cette année</MenuItem>
              <MenuItem value="year2">Ces 2 années</MenuItem>
              <MenuItem value="year3">Ces 3 années</MenuItem>
            </Select>
          </Grid>
        </div>
      </MuiPickersUtilsProvider>
    )
  }
}


RangeDate.defaultProps = {
  labelEnd: 'Date de fin',
  labelStart: 'Date de début',
}


RangeDate.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  endDate: PropTypes.object,
  labelEnd: PropTypes.string,
  startDate: PropTypes.object,
  className: PropTypes.string,
  labelStart: PropTypes.string,
  onQuickViewChange: PropTypes.func,
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(RangeDate)
